import { render, staticRenderFns } from "./PartnerDuzenle.vue?vue&type=template&id=facc15c2&scoped=true&"
import script from "./PartnerDuzenle.vue?vue&type=script&lang=js&"
export * from "./PartnerDuzenle.vue?vue&type=script&lang=js&"
import style0 from "./PartnerDuzenle.vue?vue&type=style&index=0&id=facc15c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "facc15c2",
  null
  
)

export default component.exports